module.exports = __webpack_public_path__ + "static/img/61-3.55a4b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/61-3.jpg
// module id = +ac9
// module chunks = 0